import { useEffect, useState } from 'react'
import { Box, Collapse, Grid, Typography, IconButton, useTheme } from '@mui/material';
import ButtonBasic from '../buttons/ButtonBasic';
import ListArticuloSoft from './ListArticuloSoft';
import TextInfoTicket from '../text/TextInfoTicket';
import MenuOptServicio from '../menu/MenuOptServicio';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const ListContratoSoft = ({
    tr,
    ticket,
    estadoTicket,
    onGuardar
})=>{
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [open, setOpen] = useState(false);
    const [nro, setNro] = useState(null);
    const [datos, setDatos] = useState(null);
    const [datosGral, setDatosGral] = useState(null);
    useEffect(() => {
        Object.entries(tr).map((([keys,value])=>{
            setNro(keys)
            setDatos(value ||value[0])
            setDatosGral(value)
            return ''
        }))
    }, [tr])

    return (
        <Box sx={{mt: 1}} key={`servicio${nro}`}>
            <Box
                onClick={()=>setOpen(!open)}
                sx={{
                    background: isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #1F2A40 100%)' : 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
                    border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                    borderRadius: '10px',
                    p: 1.5,
                    cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <Box sx={{
                        width: 4,
                        height: 16,
                        background: 'linear-gradient(180deg, #673ab7 0%, #9575cd 100%)',
                        borderRadius: '2px'
                    }} />
                    <Typography sx={{
                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                        fontWeight: 700,
                        fontSize: 13
                    }}>
                        Servicio: #{nro}
                    </Typography>
                </Box>
                <IconButton size="small" sx={{color: isDarkMode ? '#b39ddb' : '#673ab7'}}>
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Box>

            <Collapse in={open} sx={{mt: 1}} key={`collapse${nro}`}>
                <Box
                    sx={{
                        background: isDarkMode ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)' : 'linear-gradient(135deg, #fafbfc 0%, #f8f9fa 100%)',
                        border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e8ef',
                        borderRadius: '10px',
                        p: 2,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                    }}
                    key={`box${nro}`}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box sx={{
                                background: isDarkMode ? '#2d3a52' : '#fff',
                                p: 1.5,
                                borderRadius: '0px',
                                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e8eef5',
                                position: 'relative'
                            }}>
                                <Box sx={{position: 'absolute', top: 5, right: -15}}>
                                    <MenuOptServicio
                                        servicio={datos}
                                        ticket={ticket}
                                        estadoTicket={estadoTicket}
                                        onGuardar={onGuardar}
                                    />
                                </Box>
                                <TextInfoTicket
                                    titulo='Cuenta'
                                    descripcion={datos?.cuenta || ((Array.isArray(datos) && datos?.length > 0) && datos?.[0]?.cuenta)  || ''}
                                />
                                <TextInfoTicket
                                    titulo='Cliente'
                                    descripcion={datos?.cliente || datos?.descripcion || ((Array.isArray(datos) && datos?.length > 0) && datos?.[0]?.descripcion) || ''} 
                                />
                                <Box sx={{mt: 1}}>
                                    <TextInfoTicket
                                        titulo='Nombre'
                                        descripcion={datos?.nombre || ((Array.isArray(datos) && datos?.length > 0) && datos?.[0]?.nombre) || ((Array.isArray(datos) && datos?.length > 0) && datos?.[0]?.nombreServicio) || ''} 
                                    />
                                </Box>
                                <Box sx={{mt: 1}}>
                                    <TextInfoTicket
                                        titulo='Fec. Instalación'
                                        descripcion={
                                            datos?.instalacion
                                            || ((Array.isArray(datos) && datos?.length > 0) && datos?.[0]?.instalacion)
                                            || '-'
                                        }
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    {datosGral &&(
                        <Box sx={{mt: 0}}>
                            <ListArticuloSoft articulos={datosGral} />
                        </Box>
                    )}
                </Box>
            </Collapse>
        </Box>
    )
}

export default ListContratoSoft